export default __webpack_public_path__ + "static/rsa_lotto-19345c1fa9d4189014df5beeb2a72f0a.png";